<template>
<div class="frontend-style frontend-quality-style">
	<article class="banner" :style="{backgroundImage:'url('+Images.Quality.banner+')'}">
		<div>
			<h2>{{$t('Manufacture.manufacture')}}</h2>
		</div>
	</article>
	<section class="manufacture">
		<ManufactureFlow/>
		<div class="qualitySystem">
				<h2>{{$t('Manufacture.quality.title')}}</h2>
				<div class="quality">
					<ul>
						<li v-for="item in Images.Quality.cf">
							<img :src="item" alt="">
						</li>
					</ul>
					<h4>{{$t('Manufacture.quality.sub.cf')}}</h4>
					<p>{{$t('Manufacture.quality.sub.cfContent')}}</p>
				</div>
				<div class="equipment">
					<ul>
						<li v-for="item in Images.Quality.eq">
							<img :src="item" alt="">
						</li>
					</ul>
					<h4>{{$t('Manufacture.quality.sub.eq')}}</h4>
		  		<p>{{$t('Manufacture.quality.sub.eqContent')}}</p>
				</div>
		</div>
	</section>
</div>
</template>
<script>
	import {mapState,mapGetters} from 'vuex'
	export default{
		name:"quality",
		components:{
		
		},
		computed:{
			...mapState('frontend',[
				'Images',
				'locales'
			]),
			...mapGetters('frontend',[
				'Mobile'
			]),
			showManu(){
				return this.Manufacture[this.Key]
			}
		},
		watch:{
			Key(New,Old){
				this.EnterName = New>Old?'Right':'Left'
				this.LeaveName = New>Old?'Left':'Right'
			}
		},
		data(){
			return{
				Manufacture:{
							'A':{
								name_EN:'Wire Steel Resource',
								name_CH:'原料採購',
							},
							// 'B':{
							// 	name_EN:'Wire Rod',
							// 	name_CH:'盤元',
							// },
							'C':{
								name_EN:'Semi-finished Wire drawing',
								name_CH:'線材粗抽',
							},
							'D':{
								name_EN:'Spheroidizing Furnace',
								name_CH:'線材球化',
							},
							'E':{
								name_EN:'Surface Treatment',
								name_CH:'線材酸洗',
							},
							'F':{
								name_EN:'Finished-pass Wire drawing',
								name_CH:'線材精抽',
							},
							'G':{
								name_EN:'Screw Manufacture',
								name_CH:'螺絲製程',
								prop:'Screw'
							},
							'H':{
								name_EN:'Wire Manufacture',
								name_CH:'線材製程',
								prop:'Wire'
							},
							'I':{
								name_EN:'Heading Process',
								name_CH:'打頭製程',
							},
							'O':{
								name_EN:'Pinch Pointing',
								name_CH:'成型',
							},
							'J':{
								name_EN:'Thread Rolling Process',
								name_CH:'搓牙製程',
							},
							'K':{
								name_EN:'Heat Treatment',
								name_CH:'熱處理',
							},
							'L':{
								name_EN:'Electro Plating ＆ Coating Process',
								name_CH:'電鍍與表面處理',
							},
							'P':{
								name_EN:'Coating',
								name_CH:'烤漆',
							},
							'M':{
								name_EN:'Packaging',
								name_CH:'包裝',
							},
				},
				showing:'Wire',
				Key:'A',
				EnterName:'Left',
				LeaveName:'Right',
				scrolling:0,
				scrollTo:0,
				scrollShow:'Wire',
				timer:null
			}
		},
		methods:{
			changeCate(cata){
				this.showing = cata
			},
			showManuKey(key){
				this.Key = key!=this.Key?key:'P'
			},
			handleScroll(val){
				this.scrolling = val.target.scrollLeft
			},
			goScroll(val){
				this.$refs.wrapper.scrollLeft = val
			}
		},
		watch:{
			scrolling(val){
				this.scrollShow = val>924?'Screw':'Wire'
			}
		}
	}
</script>
